export default __webpack_public_path__ + "static/media/visual1.bfd0342e.png";